<div class="dialog-container p-0">
  <div class="flex items-center justify-between px-4 pt-4 pb-2">
    <div>
      <p class="font-bold text-lg m-0">Document Checklist</p>
      <p class="text-xs text-[#898F9E] m-0">For {{ document_name }}</p>
    </div>
    <button type="button" class="close add-close-button" (click)="closeDialog()">
      <span class="material-icons">close</span>
    </button>
  </div>
  <hr class="m-0" />
  @if(isLoading){
    @for(item of [1, 2, 3 ,4 ,5 ,6 ,7 ]; track item){
    <div class="loader-wraper w-[410px] h-[30px] mt-[20px] px-[20px]">
      <div class="loader-container h-full" [ngClass]="{ 'mt-0': true }">
        <div class="app__itemCard-placeholder h-full w-full m-0 ph-item"></div>
      </div>
    </div>
    }
    }@else {
<div class=" overflow-y-auto py-[10px] pt-2" [ngClass]=" suggested_documents.length > 0 ?'h-[360px]': ''">
  <div class="flex items-center justify-between px-4 py-2">
    <div class="font-semibold text-sm">
      Documents <span class="text-[#25508E] font-semibold">({{ suggested_documents.length }})</span>
    </div>
    <a class="text-[#25508E] text-[14px] font-bold cursor-pointer" (click)="addNewDocument($event)">+ Add New</a>
  </div>
  <!-- Outer Card Container with precise border -->
@if(suggested_documents.length > 0) {
 <div class="rounded-md overflow-hidden mb-4" style="padding: 10px;">

  <table class="w-full table-fixed border-collapse">
    <thead>
      <tr class="text-xs font-semibold text-[#898F9E] bg-white">
        <th class="w-10 p-2 border" style="border-color: #D3DCE8B2;">
          <div class="w-10">
            <div style="margin-top: -8px" id="checkbox-input-select">
              <mat-checkbox
                type="checkbox"
                class="checkbox-input custom-individual-checkBox"
                [(ngModel)]="allChecked"
                (change)="allToggleSelection(suggested_documents)"
              >
              </mat-checkbox>
            </div>
          </div>
        </th>
        <th class="text-left py-2 px-2 border" style="border-color: #D3DCE8B2;border-right: none !important;" >Name</th>
        <th class="w-10 border" style="border-color: #D3DCE8B2; border-left: none !important"></th>
      </tr>
    </thead>
    <tbody>
      @for(suggestion of suggested_documents; track suggestion.id; let i = $index) {
        <tr class="group cursor-pointer" >
          <td class="p-2 border" style="border-color: #D3DCE8B2;">
            <div class="w-10" style="margin-top: -8px" id="checkbox-input-select">
              <mat-checkbox
                type="checkbox"
                class="checkbox-input custom-individual-checkBox"
                [(ngModel)]="suggestion.isSelected"
                (change)="toggleSelection($event, suggestion, i)"
              >
              </mat-checkbox>
            </div>
          </td>
          <td
          class="text-[#18191C] text-sm font-semibold py-2 px-3 cursor-pointer"
          [style.border]="suggestion.isEditing && (!suggestion.suggestion || suggestion.suggestion.trim() === '') ? '2px solid red !important' : '1px solid #D3DCE8B2'"
          [style.border-top]="suggestion.isEditing && (!suggestion.suggestion || suggestion.suggestion.trim() === '') ? '2px solid red !important' : '1px solid #D3DCE8B2'"
          [style.border-left]="suggestion.isEditing && (!suggestion.suggestion || suggestion.suggestion.trim() === '') ? '2px solid red !important' : '1px solid #D3DCE8B2'"
          [style.border-right]="suggestion.isEditing && (!suggestion.suggestion || suggestion.suggestion.trim() === '') ? '2px solid red !important' : '1px solid #D3DCE8B2'"
          [style.border-bottom]="suggestion.isEditing && (!suggestion.suggestion || suggestion.suggestion.trim() === '') ? '2px solid red !important' : '1px solid #D3DCE8B2'"
          (click)="setEditMode($event, suggestion)"
        >
          <input
          #editableInput
          class="border-none outline-none px-2 py-1 w-full"
          [class.bg-[#A0CEFA]]="suggestion.isEditing && (suggestion.suggestion && suggestion.suggestion.trim() !== '')"
          [class.bg-[#e5c7c7b2]]="suggestion.isEditing && (!suggestion.suggestion || suggestion.suggestion.trim() === '')"
            *ngIf="suggestion.isEditing"
            type="text"
            [(ngModel)]="suggestion.suggestion"
            (blur)="saveEdit(suggestion)"
            autofocus
          />
          <span *ngIf="!suggestion.isEditing">{{ suggestion.suggestion }}</span>
        </td>
        
          <td class="py-2 pr-1 text-right border" style="border-color: #D3DCE8B2;">
            <button class=" align-middle delete-btn" (click)="deleteSuggestion(i)">
              <span
                class="material-icons text-[#FF5A5A] rounded-full p-1 cursor-pointer transition-colors duration-150
                 bg-[#FF5A5A]/10  group-hover:bg-[#eb9c9c]/10 group-focus:bg-[#EB5757]/10"
              >remove_circle_outline</span>
            </button>
          </td>
        </tr>
      }
    </tbody>
  </table>
 </div>
}@else {
  <div class="flex flex-col items-center justify-center h-full mt-[50px]">
    <img src="assets/images/cheecklist-zero-state.svg" alt="No documents found" class="w-[85px] h-[85px]">
    <p class="text-[16px] text-[#898F9E] font-semibold font-open-sans">No <span class="text-[#25508E] font-bold">Items</span> to show</p>
  </div>
}
</div>
}
@if(selectedDocuments.length >= 1) {
  <div class="floater-bar" *ngIf="selectedDocuments.length > 0">
    <div class="floater-content">
      <div class="selected-count">
      <span class="">{{ selectedDocuments.length }}</span>
        Selected
      </div>
      <button class="floater-btn floater-remove" [disabled]="!selectedDocuments.length" (click)="deleteSuggestion()">
        <span class="material-icons align-middle">remove_circle_outline</span>
        Remove
      </button>
      <button class="floater-btn floater-close" (click)="clearSelection()">
        <span class="material-icons align-middle">close</span>
        Close
      </button>
    </div>
  </div> 
}

